export const apiKey = 'AIzaSyA0XVQbO5Nb9GtGV3TrCqsV8exKnIWHFDc';
